import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import { JobsWrapperDataService } from '@core/offers-data';
import { TalentPoolsDataService } from '@core/talent-pools-data';

import type { OfferSelectDialogItem } from './offer-select.types';

@Injectable({ providedIn: 'root' })
export class OfferSelectService {
  private readonly jobsWrapperDataService = inject(JobsWrapperDataService);
  private readonly talentPoolsData = inject(TalentPoolsDataService);

  public getOffers(): Observable<OfferSelectDialogItem[]> {
    return combineLatest([
      this.jobsWrapperDataService.getActiveJobItems$().pipe(filterBoolean),
      this.talentPoolsData.collection$(),
    ]).pipe(map(results => results.flat()));
  }

  public getArchivedOffers(): Observable<OfferSelectDialogItem[]> {
    return combineLatest([
      this.jobsWrapperDataService.getArchivedJobItems$().pipe(filterBoolean),
      this.talentPoolsData.collectionBrief$(true),
    ]).pipe(map(results => results.flat()));
  }
}
